import Marquee from "react-fast-marquee";
import premisesLicenseProcessImg from "../../assets/images/Premises License Registration in Bangladesh.png";
import premisesLicenseHeaderImg from "../../assets/images/premisesLicense.png";
import Faq from "../../components/Faq";
import Meta from "../../components/Meta";
import { startupRelatedArticales } from "../../data/relatedArticale";

function PremisesLicense() {
  const faqItems = [
    {
      title: "What is a Premises License?",
      content: (
        <strong>
          A Premises License is an official authorization that allows a specific
          location to be used for regulated activities such as selling alcohol,
          providing entertainment, or serving hot food and drink late at night.
        </strong>
      ),
    },
    {
      title: "What is a Premises License model?",
      content: (
        <strong>
          A Premises License model outlines how the licensed premises will
          operate, including details like operating hours, the type of
          licensable activities, and how the licensee will comply with legal
          responsibilities.
        </strong>
      ),
    },
    {
      title: "How do I apply for a Premises License?",
      content: (
        <strong>
          To apply for a Premises License, you need to submit an application to
          the local licensing authority, including details of the premises, the
          activities you intend to carry out, and a plan to meet the licensing
          objectives.
        </strong>
      ),
    },
  ];
  return (
    <>
      <Meta
        title="Premises License Registration in Bangladesh | JK Associates"
        description="Apply for Premises License in Bangladesh. Ensure your business complies with government regulations by obtaining the required license for alcohol sales, entertainment, or late-night food services."
        image={premisesLicenseHeaderImg}
        keywords="premises license, business license Bangladesh, alcohol license, entertainment license, premises license for bsti"
      />

      <div className="container-fluid hero-header bg-light py-5 ">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-4 mb-3 animated slideInDown">
                Premises License
              </h1>
              <>A Premises License is a legal requirement in Bangladesh for any business involved in regulated activities such as serving food and beverages, alcohol, or hosting public entertainment.</>
            </div>
            <div className="col-lg-6 animated fadeIn">
              <img
                className="img-fluid animated pulse infinite"
                style={{ animationDuration: "3s" }}
                src={premisesLicenseHeaderImg}
                alt="premisesLicenseHeaderImg"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>PREMISES LICENSE REGISTRATION IN BANGLADESH</b>
          </p>
          <p>
            A Premises License is a legal requirement in Bangladesh for any
            business involved in regulated activities such as serving food and
            beverages, alcohol, or hosting public entertainment. This license is
            mandatory for businesses like restaurants, bars, clubs, cafes, and
            entertainment venues to operate legally and safely.
          </p>
          <p>
            At JK Associates, we specialize in{" "}
            <strong>
              Premises License Registration Services in Bangladesh
            </strong>
            . Our dedicated legal and business team provides end-to-end support
            for obtaining your license efficiently and with full compliance.
            From documentation to dealing with government bodies, we ensure your
            business starts and operates without interruption.
          </p>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <img
                className="img-fluid"
                src={premisesLicenseProcessImg}
                alt="Premises-License-Registration-Bangladesh"
              />
            </div>
            <div className="col-lg-6">
              <div className="h-100">
                <p className="color-text fs-5 mb-4">
                  WHY YOU NEED A PREMISES LICENSE
                </p>
                <p>
                  Operating without a Premises License can result in heavy
                  fines, business closure, and legal consequences. Having a
                  valid Premises License ensures:
                </p>
                <ul>
                  <li>Legal authority to conduct regulated activities</li>
                  <li>Compliance with local city corporation rules</li>
                  <li>Trust and transparency with customers and suppliers</li>
                  <li>
                    Eligibility to apply for other business permits like Trade
                    License or Alcohol License
                  </li>
                </ul>
                <p className="color-text fs-5 mb-4">OUR SERVICES INCLUDE:</p>
                <ul>
                  <li>Initial consultation and business assessment</li>
                  <li>
                    Preparing all required documents including trade license,
                    layout plan, and property documents
                  </li>
                  <li>Submitting applications to relevant authorities</li>
                  <li>
                    Coordinating inspections with City Corporation or relevant
                    bodies
                  </li>
                  <li>Follow-up and delivery of license</li>
                </ul>
                <p>
                  We offer affordable{" "}
                  <strong>Premises License consultancy packages</strong> for
                  both startups and established businesses. Our service is fast,
                  transparent, and designed to minimize hassle.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>DOCUMENTS REQUIRED FOR PREMISES LICENSE REGISTRATION</b>
          </p>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Trade License</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Layout Plan of the Premises</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Ownership/Lease Deed of the Business Premises</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>NID/Passport copy of the Owner/Proprietor</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Passport size photograph of the applicant</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Fire safety and sanitation clearance (if applicable)</span>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>PREMISES LICENSE REGISTRATION PROCESS IN BANGLADESH</b>
          </p>
          <p>The registration process includes the following steps:</p>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Step 1: Consultation and Eligibility Review</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Step 2: Document Preparation & Layout Planning</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>
              Step 3: Submission to City Corporation or Relevant Authority
            </span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Step 4: Inspection & Compliance Check</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Step 5: Final License Issuance</span>
          </div>
          <p>
            The process can typically be completed within 5–10 working days,
            depending on your location and business type. JK Associates ensures
            that your application is submitted accurately and followed up until
            successful approval.
          </p>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>WHY CHOOSE JK ASSOCIATES?</b>
          </p>
          <ul>
            <li>
              Experienced in handling over 500+ license registrations in
              Bangladesh
            </li>
            <li>Dedicated consultants and legal experts</li>
            <li>Fast-track service and transparent pricing</li>
            <li>Support for follow-up and renewal</li>
            <li>
              Optional packages with fire license, trade license, VAT, and TIN
            </li>
          </ul>
          <p>
            For hassle-free and affordable{" "}
            <strong>Premises License Registration in Bangladesh</strong>,
            contact JK Associates today. Let our expert team help your business
            stay compliant and grow legally.
          </p>
        </div>
      </div>

      <div className="container-xxl center-background1">
        <h2> Related Articles</h2>
      </div>

      <div className="container-xxl center-background1">
        <Marquee className="marquee-container">
          {startupRelatedArticales}
        </Marquee>
      </div>

      <div className="container py-5 my-0">
        <h2 className="color-text text-center mb-4">Uddokta Package FAQ</h2>
        <Faq items={faqItems} />
      </div>
    </>
  );
}

export default PremisesLicense;
